import {
  CircularProgress,
  CircularProgressLabel,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export type DbStatMetric = {
  kind: 'gauge' | 'stat';
  label: string;
  value: string;
  percent?: number;
};

export function DbStatsMetrics({ metrics }: { metrics: DbStatMetric[] }) {
  const gauges = metrics.filter((metric) => metric.kind === 'gauge');
  const stats = metrics.filter((metric) => metric.kind === 'stat');

  return (
    <VStack align="stretch" gap="8">
      {gauges.length > 0 ? (
        <SimpleGrid columns={{ base: 2, md: 4 }} gap="6">
          {gauges.map((gauge) => (
            <VStack key={gauge.label} gap="2">
              <CircularProgress
                value={gauge.percent ?? 0}
                size={pxToRem(112)}
                thickness={pxToRem(8)}
                color="brand.500"
                trackColor="bg.muted"
              >
                <CircularProgressLabel fontSize="md" fontWeight="semibold">
                  {gauge.value}%
                </CircularProgressLabel>
              </CircularProgress>
              <Text fontSize="sm" color="fg.muted">
                {gauge.label}
              </Text>
            </VStack>
          ))}
        </SimpleGrid>
      ) : null}

      {stats.length > 0 ? (
        <SimpleGrid columns={{ base: 2, md: 3, lg: 4 }} gap="4">
          {stats.map((stat) => (
            <Stat
              key={stat.label}
              borderWidth="1px"
              borderColor="border.default"
              borderRadius="md"
              p="4"
            >
              <StatLabel color="fg.muted">{stat.label}</StatLabel>
              <StatNumber>{stat.value}</StatNumber>
            </Stat>
          ))}
        </SimpleGrid>
      ) : null}
    </VStack>
  );
}
